import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';

import { fecthItems } from '../Actions/MenuActions'
import { updateItemRoleAddition, changeRoleName } from '../Actions/signUpAction'


const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
  },
  paper: {
    width: 200,
    height: 230,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
}));



function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

const TransferList = ({ iList, mItems, updateItemRoleAddition, addedItems }) => {


  const classes = useStyles();
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);


  useEffect(() => {

    setLeft(iList);

    console.log(mItems);



    return () => {

    }
  }, [iList, mItems])

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {

    updateItemRoleAddition(right.concat(left))

    setRight(right.concat(left));
    console.log(addedItems);
    setLeft([]);
  };

  const handleCheckedRight = () => {
    updateItemRoleAddition(right.concat(leftChecked))
    setRight(right.concat(leftChecked));
    console.log(addedItems);
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    updateItemRoleAddition(not(right, rightChecked))
    setRight(not(right, rightChecked));
    console.log(addedItems);
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    updateItemRoleAddition([])
    setRight([]);
    console.log(addedItems);
  };

  const customList = (items) => (



    <Paper className={classes.paper}>
      <List component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-item-${value.itemName}-label`;

          return (


            <ListItem key={value.itemID} role="listitem" button onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={` ${value.itemName}`} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Paper>
  );

  return (
    <Grid container spacing={2} justify="center" alignItems="center" className={classes.root}>
      <Grid item>
        <p style={{ textAlign: 'center' }}>Available Items</p>
        {customList(left)}</Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            variant="standard"
            size="small"
            className={classes.button}
            onClick={handleAllRight}
            disabled={left.length === 0}
            aria-label="move all right"
          >
            ≫
          </Button>
          <Button
            variant="standard"
            size="small"
            className={classes.button}
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            variant="standard"
            size="small"
            className={classes.button}
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
          <Button
            variant="standard"
            size="small"
            className={classes.button}
            onClick={handleAllLeft}
            disabled={right.length === 0}
            aria-label="move all left"
          >
            ≪
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <p style={{ textAlign: 'center' }}>Added Items</p>
        {customList(right)}
      </Grid>
    </Grid>
  );
}

const mapStateToProps = state => ({

  mItems: state.menu.menuItems,
  roleName: state.signUpPage.roleAdd,
  addedItems: state.signUpPage.addItemRoleList

})


export default connect(mapStateToProps, { fecthItems, updateItemRoleAddition, changeRoleName })(TransferList)